
<div class="dropdowns-container flex flex-row justify-between items-center gap-1 font-rubik">
  <!-- All Solutions Button -->
  <button
    class="dropdowns-button flex justify-center items-center transition-all nav-link"
    :class="{ active: activeButton === 'solutions' }"
    :style="activeButton === 'solutions' ? { '--active-color': '#3565FC' } : {}"
    @click="setActiveButton('solutions')"
  >
    <span>All Solutions</span>
    <span>
      <img
        :class="{ 'rotate-up': activeButton === 'solutions', 'rotate-down': activeButton !== 'solutions' }"
        src="@/images/header/drop-down-arrow.svg"
        alt="Arrow"
      />
    </span>
  </button>
  
  <!-- Guides Button -->
  <button
    class="dropdowns-button guides-button flex justify-center items-center transition-all nav-link"
    :class="{ active: activeButton === 'guides' }"
    :style="activeButton === 'guides' ? { '--active-color': '#3565FC' } : {}"
    @click="setActiveButton('guides')"
  >
    <span>Guides</span>
    <span>
      <img
        :class="{ 'rotate-up': activeButton === 'guides', 'rotate-down': activeButton !== 'guides' }"
        src="@/images/header/drop-down-arrow.svg"
        alt="Arrow"
      />
    </span>
  </button>
  
  <!-- Resources Button -->
  <button
    class="dropdowns-button flex justify-center items-center transition-all nav-link"
    :class="{ active: activeButton === 'resources' }"
    :style="activeButton === 'resources' ? { '--active-color': '#3565FC' } : {}"
    @click="setActiveButton('resources')"
  >
    <span>Resources</span>
    <span>
      <img
        :class="{ 'rotate-up': activeButton === 'resources', 'rotate-down': activeButton !== 'resources' }"
        src="@/images/header/drop-down-arrow.svg"
        alt="Arrow"
      />
    </span>
  </button>
</div>
